<template>
  <div>
    <b-card no-body class="border-0">
      <b-card-body style="">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title" @click="filterVisible = !filterVisible" role="button">
            FILTER
          </div>
          <div class="title" @click="resetFilter" role="button">RESET</div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('where_has_purchase_order_id__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('where_has_purchase_order_customer_id__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('where_has_sub_product__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('ordered_at__between')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('customer_id__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <filter-item :filter-column="resolveComponent('where_has_purchase_order_farmer_id__in')"></filter-item>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ModelFilter from "@/components/model-filter-v4";

export default {
  extends: ModelFilter,
  data() {
    return {
      filterVisible: false
    };
  }
};
</script>

<style scoped>
.multiselect__content-wrapper {
  height: 1000px !important;
}

.label-filter {
  font-weight: 500;
  font-size: 14px;
  color: #6c7589;
  margin-bottom: 5px;
}
</style>
